export class GetAdverseActionNotice {
    static readonly type = '[AdverseActionNotice] GetAdverseActionNotice';
    constructor(public dealId: number){}
}
